import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 50vw;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;

	@media (max-width: 500px) {
		width: 100%;
	}
`;

export const tabs = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
`;

export const content = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	overflow: auto;
	box-sizing: content-box;
`;
